/* global Config */
import cloneDeep from 'lodash/cloneDeep'

export default cloneDeep(Config)
